import APIPATH from "../common";

const apiCall = async (endpoint, payload) => {
        const options = {
            method: APIPATH[endpoint].method,
            credentials: 'include',
            headers: { "content-type": "application/json" },
        };
        if (payload !== undefined) {
            options.body = JSON.stringify(payload);
        }
        const httpResponse = await fetch(APIPATH[endpoint].url, options);
        if (!httpResponse.ok) {
            const errorData = await httpResponse.json();
             throw new Error(errorData.message || 'An error occurred.');
            }
        return httpResponse.json();
    };

    export default apiCall;